import React from "react";
import { Link } from "react-router-dom";
import CustomModal from "../../components/Reusable/CustomModal";
import { useTranslation } from "react-i18next";

const EducationCustomModal = (props) => {
  const { t } = useTranslation();
  const { showModal, messageType, modalTitle = "" } = props || {};
  return (
    <CustomModal show={showModal}>
      <div className="modal-popup-education-content">
        <div
          className={`education-incorrect-finish ${
            messageType === "error" ? "d-block" : "d-none"
          } `}
        >
          <div className="modal-popup-education-title">
            {t("educationModal.upss")}
          </div>
          <div className="modal-popup-education-image">
            <img
              src="/images/wrong-education.png"
              className="img-fluid"
              alt="LG"
            />
          </div>
          <div className="modal-popup-education-subtitle">
            {t("educationModal.sorry")}
          </div>
          <div
            className="modal-popup-education-description error"
            dangerouslySetInnerHTML={{ __html: modalTitle }}
          ></div>
          <div className="modal-popup-education-description-detail">
            {t("educationModal.tryAgain")}
          </div>
          <Link to="/education-list">
            <div className="modal-popup-education-button">
              {t("educationModal.returnToEducation")}
            </div>
          </Link>
        </div>
        <div
          className={`education-incorrect-finish ${
            messageType === "success" ? "d-block" : "d-none"
          } `}
        >
          <div className="modal-popup-education-title">
            {t("educationModal.congratulations")}
          </div>
          <div className="modal-popup-education-image">
            <img
              src="/images/check-education.png"
              className="img-fluid"
              alt="LG"
            />
          </div>
          <div className="modal-popup-education-subtitle">
            {t("educationModal.successfulCompletion")}
          </div>
          <div className="modal-popup-education-description success">
            {modalTitle}
          </div>
          <Link to="/education-list">
            <div className="modal-popup-education-button">
              {t("educationModal.returnToEducation")}
            </div>
          </Link>
        </div>
      </div>
    </CustomModal>
  );
};

export default EducationCustomModal;
